import React from "react";
import {useLocation, useNavigate} from "react-router-dom";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

export const CorporativoOnboardingStepper = () => {
  const colors = useDynamicColors();
  const location = useLocation();
  const navigate = useNavigate();

  const handleButtonClick = () => {
    const currentParams = location.search;
    navigate(`/vxlab-onboarding_card_id-corporativo-mobile${currentParams}`);
  };

  return (
      <div className="corporativo-stepper">
        <div className="corporativo-3">
          <div className="test-button-wrapper">
            <div
                className="test-button-2 highlighted-button"
                onClick={handleButtonClick}
            >
              <div className="text-wrapper-5">Open account</div>
            </div>
          </div>

          <div className="overlap-6">
            <div className="group-3">
              <div className="group-4">
                <div className="battery">
                  <div className="capacity-wrapper">
                    <div className="capacity" />
                  </div>

                  <img className="cap" alt="Cap" src="/img/cap-2.svg" />
                </div>

                <img className="wifi" alt="Wifi" src="/img/wifi.svg" />

                <img
                    className="cellular-connection"
                    alt="Cellular connection"
                    src="/img/cellular-connection.svg"
                />
              </div>
            </div>

            <div className="navs-statusbar">
              <div className="content-3">
                <div className="text-wrapper-7">9:50</div>

                <img className="icons" alt="Icons" src="/img/icons-6.svg" />
              </div>
            </div>

            <header className="header">
              <div className="overlap-7">
                <div className="subtitle-4">Terms and Conditions</div>

                <div className="group-5">
                  <div className="overlap-group-wrapper">
                    <div className="overlap-group-3">
                      <div className="rectangle-4" />
                      <div className="frame-3">
                        <svg
                            width={180}
                            height={170}
                            viewBox="0 0 200 190"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                              d="M204.536 85.2019L203.169 83.8348L204.536 82.4676L205.903 83.8348L204.536 85.2019Z"
                              fill="#F2F3F7"
                              fillOpacity={0.05}
                          />
                          <path
                              d="M204.536 108.113L203.169 106.746L204.536 105.379L205.903 106.746L204.536 108.113Z"
                              fill="#F2F3F7"
                              fillOpacity={0.1}
                          />
                          <path
                              d="M204.536 128.29L203.169 129.657L204.536 131.025L205.903 129.657L204.536 128.29Z"
                              fill="#F2F3F7"
                              fillOpacity={0.1}
                          />
                          <path
                              d="M204.536 151.201L203.169 152.569L204.536 153.936L205.903 152.569L204.536 151.201Z"
                              fill="#F2F3F7"
                              fillOpacity={0.05}
                          />
                          <path
                              d="M184.219 62.2908L182.852 60.9236L184.219 59.5565L185.586 60.9236L184.219 62.2908Z"
                              fill="#F2F3F7"
                              fillOpacity={0.1}
                          />
                          <path
                              d="M184.219 85.2019L182.852 83.8348L184.219 82.4676L185.586 83.8348L184.219 85.2019Z"
                              fill="#F2F3F7"
                              fillOpacity={0.15}
                          />
                          <path
                              d="M184.219 108.113L182.852 106.746L184.219 105.379L185.586 106.746L184.219 108.113Z"
                              fill="#F2F3F7"
                              fillOpacity={0.2}
                          />
                          <path
                              d="M184.219 128.29L182.852 129.657L184.219 131.025L185.586 129.657L184.219 128.29Z"
                              fill="#F2F3F7"
                              fillOpacity={0.15}
                          />
                          <path
                              d="M184.219 151.201L182.852 152.569L184.219 153.936L185.586 152.569L184.219 151.201Z"
                              fill="#F2F3F7"
                              fillOpacity={0.1}
                          />
                          <path
                              d="M184.219 174.113L182.852 175.48L184.219 176.847L185.586 175.48L184.219 174.113Z"
                              fill="#F2F3F7"
                              fillOpacity={0.05}
                          />
                          <path
                              d="M163.902 39.3794L162.535 38.0122L163.902 36.6451L165.27 38.0122L163.902 39.3794Z"
                              fill="#F2F3F7"
                              fillOpacity={0.05}
                          />
                          <path
                              d="M163.902 62.2908L162.535 60.9236L163.902 59.5565L165.27 60.9236L163.902 62.2908Z"
                              fill="#F2F3F7"
                              fillOpacity={0.15}
                          />
                          <path
                              d="M163.902 85.2019L162.535 83.8348L163.902 82.4676L165.27 83.8348L163.902 85.2019Z"
                              fill="#F2F3F7"
                              fillOpacity={0.2}
                          />
                          <path
                              d="M163.902 108.113L162.535 106.746L163.902 105.379L165.27 106.746L163.902 108.113Z"
                              fill="#F2F3F7"
                              fillOpacity={0.25}
                          />
                          <path
                              d="M163.902 128.29L162.535 129.657L163.902 131.025L165.27 129.657L163.902 128.29Z"
                              fill="#F2F3F7"
                              fillOpacity={0.2}
                          />
                          <path
                              d="M163.902 151.201L162.535 152.569L163.902 153.936L165.27 152.569L163.902 151.201Z"
                              fill="#F2F3F7"
                              fillOpacity={0.15}
                          />
                          <path
                              d="M163.902 174.113L162.535 175.48L163.902 176.847L165.27 175.48L163.902 174.113Z"
                              fill="#F2F3F7"
                              fillOpacity={0.1}
                          />
                          <path
                              d="M143.585 16.468L142.218 15.1009L143.585 13.7337L144.952 15.1009L143.585 16.468Z"
                              fill="#F2F3F7"
                              fillOpacity={0.05}
                          />
                          <path
                              d="M143.585 39.3794L142.218 38.0122L143.585 36.6451L144.952 38.0122L143.585 39.3794Z"
                              fill="#F2F3F7"
                              fillOpacity={0.2}
                          />
                          <path
                              d="M143.585 62.2908L142.218 60.9236L143.585 59.5565L144.952 60.9236L143.585 62.2908Z"
                              fill="#F2F3F7"
                              fillOpacity={0.35}
                          />
                          <path
                              d="M143.585 85.2019L142.218 83.8348L143.585 82.4676L144.952 83.8348L143.585 85.2019Z"
                              fill="#F2F3F7"
                              fillOpacity={0.45}
                          />
                          <path
                              d="M143.585 108.113L142.218 106.746L143.585 105.379L144.952 106.746L143.585 108.113Z"
                              fill="#F2F3F7"
                              fillOpacity={0.5}
                          />
                          <path
                              d="M143.585 128.29L142.218 129.657L143.585 131.025L144.952 129.657L143.585 128.29Z"
                              fill="#F2F3F7"
                              fillOpacity={0.4}
                          />
                          <path
                              d="M143.585 151.201L142.218 152.569L143.585 153.936L144.952 152.569L143.585 151.201Z"
                              fill="#F2F3F7"
                              fillOpacity={0.3}
                          />
                          <path
                              d="M143.585 174.113L142.218 175.48L143.585 176.847L144.952 175.48L143.585 174.113Z"
                              fill="#F2F3F7"
                              fillOpacity={0.2}
                          />
                          <path
                              d="M123.269 16.468L121.901 15.1009L123.269 13.7337L124.636 15.1009L123.269 16.468Z"
                              fill="#F2F3F7"
                              fillOpacity={0.15}
                          />
                          <path
                              d="M123.269 39.3794L121.901 38.0122L123.269 36.6451L124.636 38.0122L123.269 39.3794Z"
                              fill="#F2F3F7"
                              fillOpacity={0.35}
                          />
                          <path
                              d="M123.269 62.2908L121.901 60.9236L123.269 59.5565L124.636 60.9236L123.269 62.2908Z"
                              fill="#F2F3F7"
                              fillOpacity={0.5}
                          />
                          <path
                              d="M123.269 85.2019L121.901 83.8348L123.269 82.4676L124.636 83.8348L123.269 85.2019Z"
                              fill="#F2F3F7"
                              fillOpacity={0.65}
                          />
                          <path
                              d="M123.269 108.113L121.901 106.746L123.269 105.379L124.636 106.746L123.269 108.113Z"
                              fill="#F2F3F7"
                              fillOpacity={0.6}
                          />
                          <path
                              d="M123.269 128.29L121.901 129.657L123.269 131.025L124.636 129.657L123.269 128.29Z"
                              fill="#F2F3F7"
                              fillOpacity={0.55}
                          />
                          <path
                              d="M123.269 151.201L121.901 152.569L123.269 153.936L124.636 152.569L123.269 151.201Z"
                              fill="#F2F3F7"
                              fillOpacity={0.4}
                          />
                          <path
                              d="M123.269 174.113L121.901 175.48L123.269 176.847L124.636 175.48L123.269 174.113Z"
                              fill="#F2F3F7"
                              fillOpacity={0.25}
                          />
                          <path
                              d="M102.951 16.468L101.584 15.1009L102.951 13.7337L104.318 15.1009L102.951 16.468Z"
                              fill="#F2F3F7"
                              fillOpacity={0.3}
                          />
                          <path
                              d="M102.951 39.3794L101.584 38.0122L102.951 36.6451L104.318 38.0122L102.951 39.3794Z"
                              fill="#F2F3F7"
                              fillOpacity={0.55}
                          />
                          <path
                              d="M102.951 62.2908L101.584 60.9236L102.951 59.5565L104.318 60.9236L102.951 62.2908Z"
                              fill="#F2F3F7"
                              fillOpacity={0.75}
                          />
                          <path
                              d="M102.951 85.2019L101.584 83.8348L102.951 82.4676L104.318 83.8348L102.951 85.2019Z"
                              fill="#F2F3F7"
                              fillOpacity={0.8}
                          />
                          <path
                              d="M102.951 108.113L101.584 106.746L102.951 105.379L104.318 106.746L102.951 108.113Z"
                              fill="#F2F3F7"
                              fillOpacity={0.7}
                          />
                          <path
                              d="M102.951 128.29L101.584 129.657L102.951 131.025L104.318 129.657L102.951 128.29Z"
                              fill="#F2F3F7"
                              fillOpacity={0.6}
                          />
                          <path
                              d="M102.951 151.201L101.584 152.569L102.951 153.936L104.318 152.569L102.951 151.201Z"
                              fill="#F2F3F7"
                              fillOpacity={0.5}
                          />
                          <path
                              d="M102.951 174.113L101.584 175.48L102.951 176.847L104.318 175.48L102.951 174.113Z"
                              fill="#F2F3F7"
                              fillOpacity={0.35}
                          />
                          <path
                              d="M82.6348 16.468L81.2677 15.1009L82.6348 13.7337L84.002 15.1009L82.6348 16.468Z"
                              fill="#F2F3F7"
                              fillOpacity={0.4}
                          />
                          <path
                              d="M82.6348 39.3794L81.2677 38.0122L82.6348 36.6451L84.002 38.0122L82.6348 39.3794Z"
                              fill="#F2F3F7"
                              fillOpacity={0.65}
                          />
                          <path
                              d="M82.6348 62.2908L81.2677 60.9236L82.6348 59.5565L84.002 60.9236L82.6348 62.2908Z"
                              fill="#F2F3F7"
                              fillOpacity={0.9}
                          />
                          <path
                              d="M82.6348 85.2019L81.2677 83.8348L82.6348 82.4676L84.002 83.8348L82.6348 85.2019Z"
                              fill="#F2F3F7"
                          />
                          <path
                              d="M82.6348 108.113L81.2677 106.746L82.6348 105.379L84.002 106.746L82.6348 108.113Z"
                              fill="#F2F3F7"
                              fillOpacity={0.9}
                          />
                          <path
                              d="M82.6348 128.29L81.2677 129.657L82.6348 131.025L84.002 129.657L82.6348 128.29Z"
                              fill="#F2F3F7"
                              fillOpacity={0.8}
                          />
                          <path
                              d="M82.6348 151.201L81.2677 152.569L82.6348 153.936L84.002 152.569L82.6348 151.201Z"
                              fill="#F2F3F7"
                              fillOpacity={0.6}
                          />
                          <path
                              d="M82.6348 174.113L81.2677 175.48L82.6348 176.847L84.002 175.48L82.6348 174.113Z"
                              fill="#F2F3F7"
                              fillOpacity={0.45}
                          />
                          <path
                              d="M62.3174 16.468L60.9503 15.1009L62.3174 13.7337L63.6846 15.1009L62.3174 16.468Z"
                              fill="#F2F3F7"
                              fillOpacity={0.5}
                          />
                          <path
                              d="M62.3174 39.3794L60.9503 38.0122L62.3174 36.6451L63.6846 38.0122L62.3174 39.3794Z"
                              fill="#F2F3F7"
                              fillOpacity={0.7}
                          />
                          <path
                              d="M62.3174 62.2908L60.9503 60.9236L62.3174 59.5565L63.6846 60.9236L62.3174 62.2908Z"
                              fill="#F2F3F7"
                              fillOpacity={0.8}
                          />
                          <path
                              d="M62.3174 85.2019L60.9503 83.8348L62.3174 82.4676L63.6846 83.8348L62.3174 85.2019Z"
                              fill="#F2F3F7"
                              fillOpacity={0.9}
                          />
                          <path
                              d="M62.3174 108.113L60.9503 106.746L62.3174 105.379L63.6846 106.746L62.3174 108.113Z"
                              fill="#F2F3F7"
                          />
                          <path
                              d="M62.3174 128.29L60.9503 129.657L62.3174 131.025L63.6846 129.657L62.3174 128.29Z"
                              fill="#F2F3F7"
                              fillOpacity={0.9}
                          />
                          <path
                              d="M62.3174 151.201L60.9503 152.569L62.3174 153.936L63.6846 152.569L62.3174 151.201Z"
                              fill="#F2F3F7"
                              fillOpacity={0.8}
                          />
                          <path
                              d="M62.3174 174.113L60.9503 175.48L62.3174 176.847L63.6846 175.48L62.3174 174.113Z"
                              fill="#F2F3F7"
                              fillOpacity={0.5}
                          />
                          <path
                              d="M42.001 16.468L40.6339 15.1009L42.001 13.7337L43.3682 15.1009L42.001 16.468Z"
                              fill="#F2F3F7"
                              fillOpacity={0.5}
                          />
                          <path
                              d="M42.001 39.3794L40.6339 38.0122L42.001 36.6451L43.3682 38.0122L42.001 39.3794Z"
                              fill="#F2F3F7"
                              fillOpacity={0.7}
                          />
                          <path
                              d="M42.001 62.2908L40.6339 60.9236L42.001 59.5565L43.3682 60.9236L42.001 62.2908Z"
                              fill="#F2F3F7"
                              fillOpacity={0.8}
                          />
                          <path
                              d="M42.001 85.2019L40.6339 83.8348L42.001 82.4676L43.3682 83.8348L42.001 85.2019Z"
                              fill="#F2F3F7"
                              fillOpacity={0.9}
                          />
                          <path
                              d="M42.001 108.113L40.6339 106.746L42.001 105.379L43.3682 106.746L42.001 108.113Z"
                              fill="#F2F3F7"
                          />
                          <path
                              d="M42.001 128.29L40.6339 129.657L42.001 131.025L43.3682 129.657L42.001 128.29Z"
                              fill="#F2F3F7"
                              fillOpacity={0.9}
                          />
                          <path
                              d="M42.001 151.201L40.6339 152.569L42.001 153.936L43.3682 152.569L42.001 151.201Z"
                              fill="#F2F3F7"
                              fillOpacity={0.8}
                          />
                          <path
                              d="M42.001 174.113L40.6339 175.48L42.001 176.847L43.3682 175.48L42.001 174.113Z"
                              fill="#F2F3F7"
                              fillOpacity={0.7}
                          />
                          <path
                              d="M21.6836 16.468L20.3165 15.1009L21.6836 13.7337L23.0508 15.1009L21.6836 16.468Z"
                              fill="#F2F3F7"
                              fillOpacity={0.5}
                          />
                          <path
                              d="M21.6836 39.3794L20.3165 38.0122L21.6836 36.6451L23.0508 38.0122L21.6836 39.3794Z"
                              fill="#F2F3F7"
                              fillOpacity={0.7}
                          />
                          <path
                              d="M21.6836 62.2908L20.3165 60.9236L21.6836 59.5565L23.0508 60.9236L21.6836 62.2908Z"
                              fill="#F2F3F7"
                              fillOpacity={0.8}
                          />
                          <path
                              d="M21.6836 85.2019L20.3165 83.8348L21.6836 82.4676L23.0508 83.8348L21.6836 85.2019Z"
                              fill="#F2F3F7"
                              fillOpacity={0.9}
                          />
                          <path
                              d="M21.6836 108.113L20.3165 106.746L21.6836 105.379L23.0508 106.746L21.6836 108.113Z"
                              fill="#F2F3F7"
                          />
                          <path
                              d="M21.6836 128.29L20.3165 129.657L21.6836 131.025L23.0508 129.657L21.6836 128.29Z"
                              fill="#F2F3F7"
                              fillOpacity={0.9}
                          />
                          <path
                              d="M21.6836 151.201L20.3165 152.569L21.6836 153.936L23.0508 152.569L21.6836 151.201Z"
                              fill="#F2F3F7"
                              fillOpacity={0.8}
                          />
                          <path
                              d="M21.6836 174.113L20.3165 175.48L21.6836 176.847L23.0508 175.48L21.6836 174.113Z"
                              fill="#F2F3F7"
                              fillOpacity={0.7}
                          />
                          <path
                              d="M1.36625 16.468L-0.00089407 15.1009L1.36625 13.7337L2.7334 15.1009L1.36625 16.468Z"
                              fill="#F2F3F7"
                              fillOpacity={0.7}
                          />
                          <path
                              d="M1.36625 39.3794L-0.00089407 38.0122L1.36625 36.6451L2.7334 38.0122L1.36625 39.3794Z"
                              fill="#F2F3F7"
                              fillOpacity={0.8}
                          />
                          <path
                              d="M1.36625 62.2908L-0.00089407 60.9236L1.36625 59.5565L2.7334 60.9236L1.36625 62.2908Z"
                              fill="#F2F3F7"
                              fillOpacity={0.9}
                          />
                          <path
                              d="M1.36625 85.2019L-0.00089407 83.8348L1.36625 82.4676L2.7334 83.8348L1.36625 85.2019Z"
                              fill="#F2F3F7"
                              fillOpacity={0.9}
                          />
                          <path
                              d="M1.36625 108.113L-0.00089407 106.746L1.36625 105.379L2.7334 106.746L1.36625 108.113Z"
                              fill="#F2F3F7"
                          />
                          <path
                              d="M1.36625 128.29L-0.00089407 129.657L1.36625 131.025L2.7334 129.657L1.36625 128.29Z"
                              fill="#F2F3F7"
                          />
                          <path
                              d="M1.36625 151.201L-0.00089407 152.569L1.36625 153.936L2.7334 152.569L1.36625 151.201Z"
                              fill="#F2F3F7"
                          />
                          <path
                              d="M1.36625 174.113L-0.00089407 175.48L1.36625 176.847L2.7334 175.48L1.36625 174.113Z"
                              fill="#F2F3F7"
                              fillOpacity={0.9}
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </header>
          </div>

          <div className="frame-4">
            <svg
                width={72}
                height={72}
                viewBox="0 0 72 72"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path
                  d="M51.5 72L38.893 59.6009C37.7023 58.4299 37.7023 56.5528 38.893 55.399L51.5 43L64.107 55.399C65.2977 56.5701 65.2977 58.4471 64.107 59.6009L51.5 72Z"
                  fill={colors.septimo}
              />
              <path
                  d="M51.75 66.9375H20.25C18.609 66.9375 17.0352 66.2856 15.8748 65.1252C14.7144 63.9648 14.0625 62.391 14.0625 60.75V18C14.0625 16.359 14.7144 14.7852 15.8748 13.6248C17.0352 12.4644 18.609 11.8125 20.25 11.8125H23.0625V11.25C23.0625 9.60897 23.7144 8.03516 24.8748 6.87478C26.0352 5.7144 27.609 5.0625 29.25 5.0625C30.8874 5.07428 32.4544 5.72996 33.6122 6.8878C34.77 8.04563 35.4257 9.61261 35.4375 11.25V11.8125H43.1325C43.948 11.811 44.7557 11.9713 45.5089 12.2841C46.262 12.597 46.9456 13.0561 47.52 13.635L56.115 22.23C56.6939 22.8044 57.153 23.488 57.4659 24.2411C57.7787 24.9943 57.939 25.802 57.9375 26.6175V60.75C57.9375 62.391 57.2856 63.9648 56.1252 65.1252C54.9648 66.2856 53.391 66.9375 51.75 66.9375ZM20.25 15.1875C19.5041 15.1875 18.7887 15.4838 18.2613 16.0113C17.7338 16.5387 17.4375 17.2541 17.4375 18V60.75C17.4375 61.4959 17.7338 62.2113 18.2613 62.7387C18.7887 63.2662 19.5041 63.5625 20.25 63.5625H51.75C52.4959 63.5625 53.2113 63.2662 53.7387 62.7387C54.2662 62.2113 54.5625 61.4959 54.5625 60.75V28.6875H45C43.9575 28.6816 42.9594 28.2649 42.2223 27.5277C41.4851 26.7906 41.0684 25.7925 41.0625 24.75V15.1875H35.4375V20.25C35.4375 21.891 34.7856 23.4648 33.6252 24.6252C32.4648 25.7856 30.891 26.4375 29.25 26.4375C27.609 26.4375 26.0352 25.7856 24.8748 24.6252C23.7144 23.4648 23.0625 21.891 23.0625 20.25C23.0625 19.8024 23.2403 19.3732 23.5568 19.0568C23.8732 18.7403 24.3024 18.5625 24.75 18.5625C25.1976 18.5625 25.6268 18.7403 25.9432 19.0568C26.2597 19.3732 26.4375 19.8024 26.4375 20.25C26.4375 20.9959 26.7338 21.7113 27.2613 22.2387C27.7887 22.7662 28.5041 23.0625 29.25 23.0625C29.9959 23.0625 30.7113 22.7662 31.2387 22.2387C31.7662 21.7113 32.0625 20.9959 32.0625 20.25V15.1875H20.25ZM44.4375 15.5025V24.75C44.4375 24.8992 44.4968 25.0423 44.6023 25.1477C44.7077 25.2532 44.8508 25.3125 45 25.3125H54.2475C54.1027 25.0607 53.929 24.8266 53.73 24.615L45.135 16.02C44.9277 15.8159 44.6929 15.6417 44.4375 15.5025ZM26.4375 11.8125H32.0625V11.25C32.0651 10.8861 31.9948 10.5254 31.8557 10.1892C31.7166 9.85301 31.5115 9.5481 31.2525 9.2925C30.8663 8.88491 30.3661 8.60333 29.8173 8.48457C29.2685 8.36582 28.6967 8.41541 28.1765 8.62688C27.6563 8.83834 27.2121 9.20184 26.9018 9.66983C26.5916 10.1378 26.4297 10.6886 26.4375 11.25V11.8125ZM47.25 55.6875H24.75C24.3024 55.6875 23.8732 55.5097 23.5568 55.1932C23.2403 54.8768 23.0625 54.4476 23.0625 54C23.0625 53.5524 23.2403 53.1232 23.5568 52.8068C23.8732 52.4903 24.3024 52.3125 24.75 52.3125H47.25C47.6976 52.3125 48.1268 52.4903 48.4432 52.8068C48.7597 53.1232 48.9375 53.5524 48.9375 54C48.9375 54.4476 48.7597 54.8768 48.4432 55.1932C48.1268 55.5097 47.6976 55.6875 47.25 55.6875ZM47.25 46.6875H24.75C24.3024 46.6875 23.8732 46.5097 23.5568 46.1932C23.2403 45.8768 23.0625 45.4476 23.0625 45C23.0625 44.5524 23.2403 44.1232 23.5568 43.8068C23.8732 43.4903 24.3024 43.3125 24.75 43.3125H47.25C47.6976 43.3125 48.1268 43.4903 48.4432 43.8068C48.7597 44.1232 48.9375 44.5524 48.9375 45C48.9375 45.4476 48.7597 45.8768 48.4432 46.1932C48.1268 46.5097 47.6976 46.6875 47.25 46.6875ZM33.75 37.6875H24.75C24.3024 37.6875 23.8732 37.5097 23.5568 37.1932C23.2403 36.8768 23.0625 36.4476 23.0625 36C23.0625 35.5524 23.2403 35.1232 23.5568 34.8068C23.8732 34.4903 24.3024 34.3125 24.75 34.3125H33.75C34.1976 34.3125 34.6268 34.4903 34.9432 34.8068C35.2597 35.1232 35.4375 35.5524 35.4375 36C35.4375 36.4476 35.2597 36.8768 34.9432 37.1932C34.6268 37.5097 34.1976 37.6875 33.75 37.6875Z"
                  fill={colors.primario}
              />
              <path
                  d="M44.4375 15.5025V24.75C44.4375 24.8992 44.4968 25.0423 44.6023 25.1477C44.7077 25.2532 44.8508 25.3125 45 25.3125H54.2475C54.1027 25.0607 53.929 24.8266 53.73 24.615L45.135 16.02C44.9277 15.8159 44.6929 15.6417 44.4375 15.5025Z"
                  fill={colors.sexto}
              />
            </svg>

            <div className="subtitle-5">Welcome!</div>

            <p className="subtitle-6">Let’s open your online account</p>

            <div className="frame-5">
              <div className="frame-6">
                <div className="ellipse-3" />

                <div className="ellipse-3" />

                <div className="ellipse-3" />

                <div className="ellipse-3" />

                <div className="ellipse-3" />

                <div className="ellipse-3" />
              </div>

              <div className="frame-7">
                <div className="subtitle-wrapper">
                  <div className="subtitle-7">Accept Terms and Conditions</div>
                </div>

                <div className="group-6">
                  <div className="subtitle-8">Register your Email</div>
                </div>

                <div className="group-7">
                  <div className="subtitle-8">Scan your ID card</div>
                </div>

                <div className="group-8">
                  <div className="subtitle-8"> Validate your identity</div>
                </div>

                <div className="subtitle-wrapper">
                  <div className="subtitle-7">Register your Mobile number</div>
                </div>

                <div className="group-9">
                  <div className="subtitle-8">Generate your credentials</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};
